<template>
  <div>
   
    
    <div class="top-nav top-bar-mob" :class="isTopM ? 'top-bar-mob-fixed' : ''">
      <div class="">
        <div class="row">
          <div class="col-2">
            <i class="fa fa-bars" @click="visibleLeft = true"></i>

            <Sidebar :visible.sync="visibleLeft">
              <div class="px-3 py-2">
                <ul>
                  <li @click="visibleLeft = false">
                    <router-link to="/" class="course-overlay" >
                      {{ $t("Home") }}</router-link
                    >
                  </li>

                  <li v-for="item of catList" :key="item.id"  @click="visibleLeft = false">
                    <router-link
                      :to="'/service/' + item.slug"
                      class="course-overlay"
                    >
                      {{ $getByLang(item.name) }}</router-link
                    >
                  </li>

                  
                  
                  <li  @click="visibleLeft = false">
                    <router-link to="/packages" class="course-overlay">
                      {{ $t("Offer") }}</router-link
                    >
                  </li>

                  <li @click="visibleLeft = false">
                    <router-link to="/contactUs" class="course-overlay">
                      {{ $t("Contact us") }}</router-link
                    >
                  </li>
                </ul>
              </div>
            </Sidebar>
          </div>
          <div class="col-2">
            <a v-b-toggle.sidebar-2>
              <svg
                width="30"
                height="30"
                viewBox="0 0 19 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.31328 11.9153L1.56806 11.8307L1.56806 11.8307L2.31328 11.9153ZM2.76046 7.97519L3.50568 8.05977L2.76046 7.97519ZM1.44779 13.8721L0.876678 13.386H0.876678L1.44779 13.8721ZM16.4319 11.8307C16.3852 11.4191 16.0137 11.1233 15.6021 11.17C15.1906 11.2168 14.8948 11.5883 14.9415 11.9998L16.4319 11.8307ZM16.5522 13.8721L15.9811 14.3583L16.5522 13.8721ZM6.73005 3.37366L6.973 4.08322C7.2763 3.97938 7.48005 3.69424 7.48005 3.37366H6.73005ZM10.1539 2.28059C10.4237 2.59487 10.8973 2.6309 11.2115 2.36107C11.5258 2.09125 11.5618 1.61774 11.292 1.30347L10.1539 2.28059ZM12.7023 19.2632C12.8477 18.8753 12.6511 18.4431 12.2632 18.2977C11.8753 18.1523 11.4431 18.3489 11.2977 18.7368L12.7023 19.2632ZM6.7023 18.7368C6.55694 18.3489 6.12467 18.1523 5.7368 18.2977C5.34893 18.4431 5.15234 18.8753 5.2977 19.2632L6.7023 18.7368ZM17.25 6C17.25 7.24264 16.2426 8.25 15 8.25V9.75C17.0711 9.75 18.75 8.07107 18.75 6H17.25ZM15 8.25C13.7574 8.25 12.75 7.24264 12.75 6H11.25C11.25 8.07107 12.9289 9.75 15 9.75V8.25ZM12.75 6C12.75 4.75736 13.7574 3.75 15 3.75V2.25C12.9289 2.25 11.25 3.92893 11.25 6H12.75ZM15 3.75C16.2426 3.75 17.25 4.75736 17.25 6H18.75C18.75 3.92893 17.0711 2.25 15 2.25V3.75ZM14.7772 16.25H3.22281V17.75H14.7772V16.25ZM3.05849 11.9998L3.50568 8.05977L2.01525 7.89061L1.56806 11.8307L3.05849 11.9998ZM2.01889 14.3583C2.59621 13.6801 2.96028 12.8652 3.05849 11.9998L1.56806 11.8307C1.50519 12.3846 1.27067 12.9231 0.876678 13.386L2.01889 14.3583ZM14.9415 11.9998C15.0397 12.8652 15.4038 13.6801 15.9811 14.3583L17.1233 13.386C16.7293 12.9231 16.4948 12.3846 16.4319 11.8307L14.9415 11.9998ZM3.22281 16.25C2.56777 16.25 2.10443 15.926 1.89056 15.5492C1.68409 15.1854 1.68714 14.748 2.01889 14.3583L0.876678 13.386C0.111406 14.285 0.0877731 15.4116 0.585985 16.2895C1.07679 17.1544 2.04947 17.75 3.22281 17.75V16.25ZM14.7772 17.75C15.9505 17.75 16.9232 17.1544 17.414 16.2895C17.9122 15.4116 17.8886 14.285 17.1233 13.386L15.9811 14.3583C16.3129 14.748 16.3159 15.1854 16.1094 15.5492C15.8956 15.926 15.4322 16.25 14.7772 16.25V17.75ZM7.48005 3.37366V3.26995H5.98005V3.37366H7.48005ZM3.50568 8.05977C3.7087 6.27101 5.05587 4.73962 6.973 4.08322L6.48711 2.6641C4.11944 3.47476 2.29449 5.43026 2.01525 7.89061L3.50568 8.05977ZM9 0.25C7.33213 0.25 5.98005 1.60208 5.98005 3.26995H7.48005C7.48005 2.4305 8.16056 1.75 9 1.75V0.25ZM9 1.75C9.46131 1.75 9.87403 1.95459 10.1539 2.28059L11.292 1.30347C10.7393 0.659712 9.91709 0.25 9 0.25V1.75ZM11.2977 18.7368C10.975 19.5979 10.0846 20.25 9 20.25V21.75C10.6855 21.75 12.1516 20.7325 12.7023 19.2632L11.2977 18.7368ZM9 20.25C7.91542 20.25 7.02502 19.5979 6.7023 18.7368L5.2977 19.2632C5.84835 20.7325 7.31452 21.75 9 21.75V20.25Z"
                  fill="#fff"
                />
              </svg>
            </a>
          </div>
          <div class="col-2">
            <router-link to="/google-map">
              <i class="fa fa-map-marker"></i>
            </router-link>
          </div>
          <div class="col-2">
            <!-- <router-link to="/contactUs">
              <i class="fa fa-comments-o"></i>
            </router-link> -->
            <b-dropdown
              v-if="user"
              variant="link"
              class="xxxssxdnjxdnj"
              toggle-class="text-decoration-none "
              no-caret
              style="z-index: 999;"
            >
              <template #button-content>
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 16 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M3.94874 5.47436C3.94874 3.34311 5.67646 1.61538 7.80771 1.61538C9.93897 1.61538 11.6667 3.34311 11.6667 5.47436C11.6667 7.60561 9.93897 9.33333 7.80771 9.33333C5.67646 9.33333 3.94874 7.60561 3.94874 5.47436ZM7.80771 0C4.78431 0 2.33336 2.45095 2.33336 5.47436C2.33336 8.49776 4.78431 10.9487 7.80771 10.9487C10.8311 10.9487 13.2821 8.49776 13.2821 5.47436C13.2821 2.45095 10.8311 0 7.80771 0ZM2.74565 15.4584C3.46935 14.7347 4.4509 14.3281 5.47436 14.3281H10.141C11.1645 14.3281 12.146 14.7347 12.8697 15.4584C13.5934 16.1821 14 17.1636 14 18.1871V20.5204C14 20.9665 14.3616 21.3281 14.8077 21.3281C15.2538 21.3281 15.6154 20.9665 15.6154 20.5204V18.1871C15.6154 16.7352 15.0386 15.3428 14.012 14.3161C12.9853 13.2895 11.5929 12.7127 10.141 12.7127H5.47436C4.02247 12.7127 2.63004 13.2895 1.6034 14.3161C0.576761 15.3428 0 16.7352 0 18.1871V20.5204C0 20.9665 0.361616 21.3281 0.807692 21.3281C1.25377 21.3281 1.61538 20.9665 1.61538 20.5204V18.1871C1.61538 17.1636 2.02195 16.1821 2.74565 15.4584Z"
                    fill="#fff"
                  />
                </svg>
              </template>

              <b-dropdown-item @click="$router.push('/myprofile')">
                <i class="fa fa-user"></i> {{ $t("myprofile") }}
              </b-dropdown-item>
             
              
              <b-dropdown-item @click="$router.push('/packagesuser')">
                <i class="fa fa-shopping-bag "></i> {{ $t("mypackages") }}
              </b-dropdown-item>

              <!-- <b-dropdown-item @click="$router.push('/myreservations')">
                <i class="fa fa-calendar "></i> {{ $t("myreservations") }}
              </b-dropdown-item> -->

              <b-dropdown-item @click="$router.push('/supportTickets')">
                <i class="fa fa-ticket "></i> {{ $t("Support tickets") }}
              </b-dropdown-item>

              <b-dropdown-item @click="logout">
                <i class="fa fa-sign-out"></i> {{ $t("logout") }}
              </b-dropdown-item>
            </b-dropdown>

            <router-link to="/login" v-else>
              <svg
                width="30"
                height="30"
                viewBox="0 0 16 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M3.94874 5.47436C3.94874 3.34311 5.67646 1.61538 7.80771 1.61538C9.93897 1.61538 11.6667 3.34311 11.6667 5.47436C11.6667 7.60561 9.93897 9.33333 7.80771 9.33333C5.67646 9.33333 3.94874 7.60561 3.94874 5.47436ZM7.80771 0C4.78431 0 2.33336 2.45095 2.33336 5.47436C2.33336 8.49776 4.78431 10.9487 7.80771 10.9487C10.8311 10.9487 13.2821 8.49776 13.2821 5.47436C13.2821 2.45095 10.8311 0 7.80771 0ZM2.74565 15.4584C3.46935 14.7347 4.4509 14.3281 5.47436 14.3281H10.141C11.1645 14.3281 12.146 14.7347 12.8697 15.4584C13.5934 16.1821 14 17.1636 14 18.1871V20.5204C14 20.9665 14.3616 21.3281 14.8077 21.3281C15.2538 21.3281 15.6154 20.9665 15.6154 20.5204V18.1871C15.6154 16.7352 15.0386 15.3428 14.012 14.3161C12.9853 13.2895 11.5929 12.7127 10.141 12.7127H5.47436C4.02247 12.7127 2.63004 13.2895 1.6034 14.3161C0.576761 15.3428 0 16.7352 0 18.1871V20.5204C0 20.9665 0.361616 21.3281 0.807692 21.3281C1.25377 21.3281 1.61538 20.9665 1.61538 20.5204V18.1871C1.61538 17.1636 2.02195 16.1821 2.74565 15.4584Z"
                  fill="#fff"
                />
              </svg>
            </router-link>
          </div>
          <div class="col-2 " style="padding: 0;text-align: center;">
            <router-link to="/booking/0" style="color: #fff;font-weight: 600;">
              <!-- <i class="fa fa-calendar-check-o"></i> -->
              {{ $t("Calendar") }}
            </router-link>
          </div>
          <div class="col-2" style="border-right: none;">
            <a href="tel:+436601021010">
              <i class="fa fa-volume-control-phone"></i>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!--  newstart -->

    <nav
      class="navbar row tttpppp  "
      :class="isTop ? 'fixed-top' : ''"
      style="background-color: rgba(255,255,255,.8) !important;z-index: 10;width: 100vw;margin: 0;padding-bottom: 0;padding-top: 0;"
    >
      <div class="logo col-md-2 col-8" style="text-align: start;">
        <router-link to="/">
          <img src="/image/logo.png" alt="" class="clogogoo" style="" />
        </router-link>
      </div>

      <div class="icons col-md-10 col-4 mob-icon">
        <div class="mt-2" style="text-align: end;" v-if="!isMob()">
          <b-dropdown
            variant="link"
            toggle-class="text-decoration-none"
            no-caret
            style="z-index: 99999999;margin-left: 3%;"
            class="xmnulang"
          >
            <template #button-content>
              <img :src="`/image/flags/${lang}.png`" style="width: 18px;" />
              <span style="color:#000">
                {{ lang == "en" ? "English" : "Deutsch" }}
              </span>
            </template>
            <b-dropdown-item @click="changeLang('en')">
              <img src="/image/flags/en.png" style="width: 28px;" />
              English
            </b-dropdown-item>
            <b-dropdown-item @click="changeLang('de')">
              <img src="/image/flags/de.png" style="width: 28px;" />
              Deutsch
            </b-dropdown-item>
          </b-dropdown>

          <a v-b-toggle.sidebar-2>
            <svg
              width="18"
              height="22"
              viewBox="0 0 18 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style="margin-left: 10px;"
            >
              <path
                d="M2.31328 11.9153L1.56806 11.8307L1.56806 11.8307L2.31328 11.9153ZM2.76046 7.97519L3.50568 8.05977L2.76046 7.97519ZM1.44779 13.8721L0.876678 13.386H0.876678L1.44779 13.8721ZM16.4319 11.8307C16.3852 11.4191 16.0137 11.1233 15.6021 11.17C15.1906 11.2168 14.8948 11.5883 14.9415 11.9998L16.4319 11.8307ZM16.5522 13.8721L15.9811 14.3583L16.5522 13.8721ZM6.73005 3.37366L6.973 4.08322C7.2763 3.97938 7.48005 3.69424 7.48005 3.37366H6.73005ZM10.1539 2.28059C10.4237 2.59487 10.8973 2.6309 11.2115 2.36107C11.5258 2.09125 11.5618 1.61774 11.292 1.30347L10.1539 2.28059ZM12.7023 19.2632C12.8477 18.8753 12.6511 18.4431 12.2632 18.2977C11.8753 18.1523 11.4431 18.3489 11.2977 18.7368L12.7023 19.2632ZM6.7023 18.7368C6.55694 18.3489 6.12467 18.1523 5.7368 18.2977C5.34893 18.4431 5.15234 18.8753 5.2977 19.2632L6.7023 18.7368ZM17.25 6C17.25 7.24264 16.2426 8.25 15 8.25V9.75C17.0711 9.75 18.75 8.07107 18.75 6H17.25ZM15 8.25C13.7574 8.25 12.75 7.24264 12.75 6H11.25C11.25 8.07107 12.9289 9.75 15 9.75V8.25ZM12.75 6C12.75 4.75736 13.7574 3.75 15 3.75V2.25C12.9289 2.25 11.25 3.92893 11.25 6H12.75ZM15 3.75C16.2426 3.75 17.25 4.75736 17.25 6H18.75C18.75 3.92893 17.0711 2.25 15 2.25V3.75ZM14.7772 16.25H3.22281V17.75H14.7772V16.25ZM3.05849 11.9998L3.50568 8.05977L2.01525 7.89061L1.56806 11.8307L3.05849 11.9998ZM2.01889 14.3583C2.59621 13.6801 2.96028 12.8652 3.05849 11.9998L1.56806 11.8307C1.50519 12.3846 1.27067 12.9231 0.876678 13.386L2.01889 14.3583ZM14.9415 11.9998C15.0397 12.8652 15.4038 13.6801 15.9811 14.3583L17.1233 13.386C16.7293 12.9231 16.4948 12.3846 16.4319 11.8307L14.9415 11.9998ZM3.22281 16.25C2.56777 16.25 2.10443 15.926 1.89056 15.5492C1.68409 15.1854 1.68714 14.748 2.01889 14.3583L0.876678 13.386C0.111406 14.285 0.0877731 15.4116 0.585985 16.2895C1.07679 17.1544 2.04947 17.75 3.22281 17.75V16.25ZM14.7772 17.75C15.9505 17.75 16.9232 17.1544 17.414 16.2895C17.9122 15.4116 17.8886 14.285 17.1233 13.386L15.9811 14.3583C16.3129 14.748 16.3159 15.1854 16.1094 15.5492C15.8956 15.926 15.4322 16.25 14.7772 16.25V17.75ZM7.48005 3.37366V3.26995H5.98005V3.37366H7.48005ZM3.50568 8.05977C3.7087 6.27101 5.05587 4.73962 6.973 4.08322L6.48711 2.6641C4.11944 3.47476 2.29449 5.43026 2.01525 7.89061L3.50568 8.05977ZM9 0.25C7.33213 0.25 5.98005 1.60208 5.98005 3.26995H7.48005C7.48005 2.4305 8.16056 1.75 9 1.75V0.25ZM9 1.75C9.46131 1.75 9.87403 1.95459 10.1539 2.28059L11.292 1.30347C10.7393 0.659712 9.91709 0.25 9 0.25V1.75ZM11.2977 18.7368C10.975 19.5979 10.0846 20.25 9 20.25V21.75C10.6855 21.75 12.1516 20.7325 12.7023 19.2632L11.2977 18.7368ZM9 20.25C7.91542 20.25 7.02502 19.5979 6.7023 18.7368L5.2977 19.2632C5.84835 20.7325 7.31452 21.75 9 21.75V20.25Z"
                fill="#313131"
              />
            </svg>
          </a>

          <b-dropdown
            v-if="user"
            variant="link"
            class="xxxssxdnjxdnj"
            toggle-class="text-decoration-none "
            no-caret
            style="z-index: 999;"
          >
            <template #button-content>
              <svg
                width="18"
                height="22"
                viewBox="0 0 18 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style="margin-left: 10px;"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M3.94874 5.47436C3.94874 3.34311 5.67646 1.61538 7.80771 1.61538C9.93897 1.61538 11.6667 3.34311 11.6667 5.47436C11.6667 7.60561 9.93897 9.33333 7.80771 9.33333C5.67646 9.33333 3.94874 7.60561 3.94874 5.47436ZM7.80771 0C4.78431 0 2.33336 2.45095 2.33336 5.47436C2.33336 8.49776 4.78431 10.9487 7.80771 10.9487C10.8311 10.9487 13.2821 8.49776 13.2821 5.47436C13.2821 2.45095 10.8311 0 7.80771 0ZM2.74565 15.4584C3.46935 14.7347 4.4509 14.3281 5.47436 14.3281H10.141C11.1645 14.3281 12.146 14.7347 12.8697 15.4584C13.5934 16.1821 14 17.1636 14 18.1871V20.5204C14 20.9665 14.3616 21.3281 14.8077 21.3281C15.2538 21.3281 15.6154 20.9665 15.6154 20.5204V18.1871C15.6154 16.7352 15.0386 15.3428 14.012 14.3161C12.9853 13.2895 11.5929 12.7127 10.141 12.7127H5.47436C4.02247 12.7127 2.63004 13.2895 1.6034 14.3161C0.576761 15.3428 0 16.7352 0 18.1871V20.5204C0 20.9665 0.361616 21.3281 0.807692 21.3281C1.25377 21.3281 1.61538 20.9665 1.61538 20.5204V18.1871C1.61538 17.1636 2.02195 16.1821 2.74565 15.4584Z"
                  fill="#313131"
                />
              </svg>
            </template>

            <b-dropdown-item @click="$router.push('/myprofile')">
              <i class="fa fa-user"></i> {{ $t("myprofile") }}
            </b-dropdown-item>
            
            
            <b-dropdown-item @click="$router.push('/packagesuser')">
              <i class="fa fa-shopping-bag "></i> {{ $t("mypackages") }}
            </b-dropdown-item>

            <!-- <b-dropdown-item @click="$router.push('/myreservations')">
                <i class="fa fa-calendar "></i> {{ $t("myreservations") }}
              </b-dropdown-item> -->



            <b-dropdown-item @click="$router.push('/supportTickets')">
              <i class="fa fa-ticket "></i> {{ $t("Support tickets") }}
            </b-dropdown-item>

            <b-dropdown-item @click="logout">
              <i class="fa fa-sign-out"></i> {{ $t("logout") }}
            </b-dropdown-item>
          </b-dropdown>

          <router-link to="/login" v-else>
            <svg
              width="18"
              height="22"
              viewBox="0 0 18 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style="margin-left: 10px;"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.94874 5.47436C3.94874 3.34311 5.67646 1.61538 7.80771 1.61538C9.93897 1.61538 11.6667 3.34311 11.6667 5.47436C11.6667 7.60561 9.93897 9.33333 7.80771 9.33333C5.67646 9.33333 3.94874 7.60561 3.94874 5.47436ZM7.80771 0C4.78431 0 2.33336 2.45095 2.33336 5.47436C2.33336 8.49776 4.78431 10.9487 7.80771 10.9487C10.8311 10.9487 13.2821 8.49776 13.2821 5.47436C13.2821 2.45095 10.8311 0 7.80771 0ZM2.74565 15.4584C3.46935 14.7347 4.4509 14.3281 5.47436 14.3281H10.141C11.1645 14.3281 12.146 14.7347 12.8697 15.4584C13.5934 16.1821 14 17.1636 14 18.1871V20.5204C14 20.9665 14.3616 21.3281 14.8077 21.3281C15.2538 21.3281 15.6154 20.9665 15.6154 20.5204V18.1871C15.6154 16.7352 15.0386 15.3428 14.012 14.3161C12.9853 13.2895 11.5929 12.7127 10.141 12.7127H5.47436C4.02247 12.7127 2.63004 13.2895 1.6034 14.3161C0.576761 15.3428 0 16.7352 0 18.1871V20.5204C0 20.9665 0.361616 21.3281 0.807692 21.3281C1.25377 21.3281 1.61538 20.9665 1.61538 20.5204V18.1871C1.61538 17.1636 2.02195 16.1821 2.74565 15.4584Z"
                fill="#313131"
              />
            </svg>
          </router-link>
        </div>
        <div v-else>
          <b-dropdown
            variant="link"
            toggle-class="text-decoration-none"
            no-caret
            style="z-index: 99999999;margin-left: 3%;"
          >
            <template #button-content>
              <img :src="`/image/flags/${lang}.png`" style="width: 18px;" />
              <span style="color:#000">
                {{ lang == "en" ? "En" : "De" }}
              </span>
            </template>
            <b-dropdown-item @click="changeLang('en')">
              <img src="/image/flags/en.png" style="width: 28px;" />
              En
            </b-dropdown-item>
            <b-dropdown-item @click="changeLang('de')">
              <img src="/image/flags/de.png" style="width: 28px;" />
              De
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="newNavBarX mb-2 mt-2" v-if="!isMob()">
          <ul class="nav nav-pills">
            <li class="nav-item">
              <router-link to="/" class="nav-link active">{{
                $t("Home")
              }}</router-link>
            </li>

            <li class="nav-item" v-for="io of catList">
              <router-link :to="'/service/' + io.slug" class="nav-link  ">
                {{ $getByLang(io.name) }}
              </router-link>
            </li>

            <li class="nav-item">
              <router-link to="/packages" class="nav-link  ">
                {{ $t("Offer") }}
              </router-link>
            </li>

            
            

            <!-- <li class="nav-item">
              <router-link to="/Production/0" class="nav-link  ">
                {{ $t("Our Production") }}
              </router-link>
            </li> -->

            <li class="nav-item login" style="margin-left: 5%;">
              <router-link to="/booking/0" class="nav-link  ">
                {{ $t("Calendar") }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <b-sidebar
      id="sidebar-2"
      title="Sidebar"
      shadow
      right
      width="30vw"
      :style="isTopM ? 'padding-top: 64px;' : ''"
    >
      <div class="px-3 py-2">
        <p>
          Cras mattis consectetur purus sit amet fermentum. Cras justo odio,
          dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac
          consectetur ac, vestibulum at eros.
        </p>
        <b-img
          src="https://picsum.photos/500/500/?image=54"
          fluid
          thumbnail
        ></b-img>
      </div>
    </b-sidebar>


  </div>
</template>

<script>
export default {
  name: "app-header",
  data() {
    const lang = localStorage.lang || "de";

    const user = localStorage.userKB ? JSON.parse(localStorage.userKB) : "";

    return {
      list: [],
      services: [],
      packakes: [],
      isTop: null,
      isTopM: null,
      lang,

      countCartItem: 0,
      countItem: 0,
      cartlist: [],
      user,
      catList: [],
      visibleLeft: false,
    };
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  created() {
    this.$http.get(`sections?parntId=null`).then((res) => {
      this.catList = res.data.data;
    });
    window.addEventListener("scroll", this.handleScroll);
    this.$http.get(`page?typePage=header`).then(
      (res) => {
        this.list = res.data;
      },
      (err) => {
        console.log(err);
      }
    );

    this.$http.get("services").then(
      (res) => {
        this.services = res.data;
      },
      (err) => {
        console.log(err);
      }
    );

    this.$http.get("packages").then(
      (res) => {
        this.packakes = res.data;
      },
      (err) => {
        console.log(err);
      }
    );
  },
  mounted() {
    this.getNewCount();
    this.$eventHub.$on("addItem", () => {
      this.getNewCount();
    });
  },
  methods: {
    isMob() {
      var windowWidth = window.innerWidth;

      return windowWidth < 750;
    },
    logout() {
      delete localStorage.userKB;
      location.reload();
    },
    remove(index) {
      this.cartlist.splice(index, 1);
      localStorage.itemsList = JSON.stringify(this.cartlist);
      this.$eventHub.$emit("addItem", {});
    },
    getNewCount() {
      this.cartlist = localStorage.itemsList
        ? JSON.parse(localStorage.itemsList)
        : [];

      this.countCartItem = this.cartlist
        .map((item) => item.quantity)
        .reduce((x, y) => x + y, 0);
    },
    chane() {
      localStorage.itemsList = JSON.stringify(this.cartlist);
      this.$eventHub.$emit("addItem", {});
    },

    changeLang(val) {
      localStorage.lang = val;
      this.$root.$i18n.locale = val;
      this.lang = val;
    },
    handleScroll(event) {
      if (window.innerWidth > 890) {
        if (window.scrollY > 890) {
          this.isTop = "top";
        } else {
          this.isTop = null;
        }
      }

      if (window.innerWidth < 890) {
        if (window.scrollY > 890) {
          this.isTopM = "top";
        } else {
          this.isTopM = null;
        }
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.xmenu .dropdown-menu {
  position: absolute;
  width: 86vw;
  left: -26vw;
  box-shadow: 0px 7px 12px -4px rgba(0, 0, 0, 0.45);
  background: url("/image/mm-col-bg.png") no-repeat right bottom, #fff;
}

.xmenu span {
  color: rgba(0, 0, 0, 0.5);
}
.xmenu .row {
  margin: 0;
  padding: 20px 10px;
}

.xmenu .row p {
  font-size: 12px;
  color: #203245;
}
.cor-con-mid p,
li {
  color: #8b4513;
  line-height: 24px;
  font-size: 15px;
  font-weight: 400;
}
.xmenu ul li {
  display: block;
  width: 100%;
  position: relative;
  padding-left: 15px;
}
.xmenu ul li a {
  font-size: 14px;
  color: #203245;
  line-height: 31px;
  padding: 5px;
  text-transform: capitalize;
}

.xmenu ul li::before {
  content: "\f105";
  font-family: FontAwesome;
  font-style: normal;
  font-weight: normal;
  text-decoration: inherit;
  color: #000;
  font-size: 16px;
  padding-right: 0.5em;
  position: absolute;
  top: 5px;
  left: 0;
}
.xmenu ul li a {
  color: #fff;
  padding: 20px 10px;
  line-height: 60px;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  position: relative;
}
.xmenu ul li a {
  font-size: 14px;
  color: #203245;
  line-height: 31px;
  padding: 5px;
  text-transform: capitalize;
}
.xmenu ul li a::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 3px;
  bottom: 12px;
  left: 0;
  color: #e66030;
  background-color: #e66030;
  visibility: hidden;
  -webkit-transform: scaleX(0);
  transform: scaleX(0);
  transition: all 0.15s ease-in;
  z-index: 1;
}

.xmenu ul li a:after {
  bottom: 0px;
}

@media screen and (min-width: 890px) {
  .top-bar {
    display: block;
  }
  .navbar {
    display: flex;
    text-align: center;
  }
  .logo-img {
    height: 50px !important;
  }
  .top-bar-mob {
    display: none;
  }
  .top-bar i {
    color: #fff;
    font-size: 18px;
  }
  .top-bar .col-1 {
    padding: 0.375rem 0.75rem;
  }
  .top-bar button {
    padding: 0;
  }
}

@media screen and (max-width: 890px) {
  .top-bar {
    display: none;
  }
  .navbar {
    /* display: block; */
    text-align: center;
  }
  .bg-dark {
    min-height: 72px !important;
  }

  .navbar-brand {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .logo-img {
    height: 57px !important;
  }
  .navbar-brand {
    margin: auto !important;
  }
  .top-bar-mob {
    display: block;
    height: 59px;
    background-color: #cbb283 !important;
    border-bottom: 1px solid #b08a16;
    z-index: 9999999;
    position: relative;
  }
  .bg-dark {
    z-index: auto !important;
  }
  .top-bar-mob-fixed {
    height: 59px;
    position: fixed;
    z-index: 99999999999999999999999;
    width: 100%;
  }
  .top-bar-mob .col-2 {
    font-size: 30px;
    color: #863902 !important;
    border-right: 1px solid #fff;
    text-align: center;
  }

  .top-bar-mob i {
    font-size: 30px;
    color: #fff !important;
  }

  .b-sidebar {
    text-align: left !important;
    width: auto !important;
  }
  .b-sidebar a {
    color: #8f5225 !important;
  }
  .top-nav ul {
    padding: 0 !important;
  }
  .top-nav ul li {
    margin-bottom: 1rem !important;
  }
}

/*-------------------------------------------------*/
.icon-float {
  position: fixed;
  /* left: 0px;
     */
  top: 35%;
  z-index: 999;
  right: 0px;
}
.icon-float ul {
  padding: 0px;
}
.icon-float ul li {
  list-style-type: none;
}
.icon-float ul li a {
  display: block;
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  padding: 0px;
}
.icon-float ul li a i {
  padding: 8px;
  width: 40px;
  height: 32px;
  text-align: center;
  color: #fff;
}
.icon-float ul li a:hover {
  transform: rotateY(-180deg);
}
.icon-float ul li a:hover i {
  transform: rotateY(180deg);
}
.fb1 {
  background: #3b5998;
}
.gp1 {
  background: #dd4b39;
}
.tw1 {
  background: #1da1f2;
}
.li1 {
  background: #0077b5;
}
.yt1 {
  background: #cd201f;
}
.wa1 {
  background: #34af23;
}
.sh {
  background: #fff;
  padding: 10px 0px;
  font-size: 11px;
  text-align: center;
  color: #333;
  /* border-top-left-radius: 5px; */
}
.sh1 {
  background: #333;
  /* border-bottom-left-radius: 5px; */
}

.navbar-expand-lg .navbar-nav .dropdown-menu {
  box-shadow: 0px 7px 12px -4px rgba(0, 0, 0, 0.45);
  /* background: url('../assets/mm-col-bg.png') no-repeat right bottom, #fff; */
}

.navbar .icons a {
  color: #313131;
  /* margin: 0 14px; */
  font-size: 20px;
}

.xxxssxdnjxdnj a {
  margin: 0 !important;
  font-size: 15px !important;
}
.xxxssxdnjxdnj .icons a i {
  margin-right: 7px;
}

.p-sidebar-left {
  width: 15rem !important;
  background-color: #ffffffb8 !important;
}
.p-sidebar-left a {
  color: #000;
  font-weight: bold;
}
</style>